const KEY = 'proteauto_original_origem';

export interface OriginalOrigemData {
  referrer: string;
  landing_url: string;
}

export default class OriginalOrigem {
  public static get(): OriginalOrigemData {
    const stored = sessionStorage.getItem(KEY);
    if (stored !== null) {
      return JSON.parse(stored);
    }

    const value: OriginalOrigemData = {
      referrer: document.referrer,
      landing_url: window.location.href,
    };
    sessionStorage.setItem(KEY, JSON.stringify(value));
    return value;
  }
}
